import { Toaster } from 'sonner';
import { useEchoHireTheme } from '@/theme/ThemeProvider';

export default function AppToaster() {
  const { resolvedMode } = useEchoHireTheme();
  return <Toaster theme={resolvedMode === 'dark' ? 'dark' : 'light'} richColors position="top-right" closeButton />;
}
